import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { BREAKPOINTS } from './breakpoints.js';

export function initUpcomingEvents() {
  const carousels = document.querySelectorAll('.cmp-upcomingevents');

  carousels.forEach((carousel) => {
    const swiperEl = carousel.querySelector('.swiper');
    const nextBtn = carousel.querySelector('.swiper-button-next');
    const prevBtn = carousel.querySelector('.swiper-button-prev');
    const mobileNextBtn = carousel.querySelector('.swiper-button-next-mobile');
    const mobilePrevBtn = carousel.querySelector('.swiper-button-prev-mobile');

    if (!swiperEl) return;

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: [nextBtn, mobileNextBtn],
        prevEl: [prevBtn, mobilePrevBtn],
      },
      loop: true,
      speed: 500,
      allowTouchMove: window.innerWidth > BREAKPOINTS.LARGE,
    });
  });
}